import { useRoute } from 'vue-router'
import { setPageLayout } from '#imports'

/** Espelha layouts em src/layouts (Nuxt 4 não reexporta LayoutKey de forma estável para tsc). */
type LayoutKey = 'auth' | 'clean' | 'dashboard' | 'default'

export function useLayoutForPath (path?: string): void {
  const availableLayouts: LayoutKey[] = ['dashboard', 'auth']

  const route = useRoute()
  const firstSegment = (path ?? route.path)?.split('/')?.[1]
  const inferredLayoutName = firstSegment === 'dashboard-v3'
    ? 'dashboard'
    : availableLayouts.includes(firstSegment as LayoutKey)
      ? (firstSegment as LayoutKey)
      : undefined

  useLayout(inferredLayoutName)
}

export function useLayout (layout?: LayoutKey): void {
  // Nuxt 4 tipa setPageLayout com NuxtLayouts de pages/runtime (vazio).
  const setLayout = setPageLayout as (name?: LayoutKey) => void
  setLayout(layout)
}
